import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const rows = [{
  method: 'Cardio intenso (30-60 min)',
  why: 'Sube aún más el cortisol. Tu cuerpo lo interpreta como “huir del depredador”, disparando más alarma.'
}, {
  method: 'Restricción calórica',
  why: 'Envía la señal de “hambruna”. El cuerpo retiene aún más sodio y grasa.'
}, {
  method: 'Dietas sin grasas',
  why: 'Las grasas saludables regulan el cortisol. Sin ellas, la inflamación persiste.'
}, {
  method: 'Ayuno intermitente (con estrés)',
  why: 'Puede aumentar el cortisol en mujeres estresadas. Es “otra privación” para el cuerpo.'
}];
export function WhyMethodsFail() {
  return <section className="w-full bg-cream py-16 sm:py-24" aria-labelledby="metodos-title" data-id="element-395" data-mp="3dwzeaa6zybsy">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-396" data-mp="3dv52bldpdu10">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-14" data-id="element-397" data-mp="f7r4k62htb5w">
          <Reveal data-id="element-398" data-mp="af7q76vzec01">
            <p className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-399" data-mp="aeoalwtszzp6">
              Por qué fallan los métodos convencionales
            </p>
            <h2 id="metodos-title" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-bark sm:text-[2.6rem]" data-id="element-400" data-mp="ge2gbtyn282o">
              El error que estás cometiendo sin saberlo
            </h2>
            <p className="mt-5 text-base leading-relaxed text-ink/85" data-id="element-401" data-mp="6modpdbe4s5b">
              Si estás en estado de estrés crónico y haces esto, no estás avanzando: estás
              empeorando el cuadro.
            </p>
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/2cc7fe43-8b07-42b0-b722-f95be9bffa71.jpg" alt="Ilustración de una mujer corriendo con una curva de cortisol que sube en lugar de bajar" className="mt-8 w-full rounded-2xl border border-bark/10 object-cover shadow-soft" loading="lazy" data-id="element-402" data-mp="3tt8od6usdesn" />
          </Reveal>

          <Reveal delay={0.05} data-id="element-403" data-mp="1dzgoavpp6ram">
            <ul className="divide-y divide-bark/10 overflow-hidden rounded-2xl border border-bark/10 bg-sand/40" data-id="element-404" data-mp="1i3emn4777y2m">
              <li className="grid grid-cols-[1fr] gap-1 bg-bark px-6 py-3 text-xs font-semibold uppercase tracking-widest text-cream/70 sm:grid-cols-[220px_1fr] sm:gap-6" data-id="element-405" data-mp="2r0wb16jwy1r0">
                <span data-id="element-406" data-mp="2hyve6asldhpv">Método convencional</span>
                <span className="hidden sm:block" data-id="element-407" data-mp="2hzooflqrepcr">Por qué falla</span>
              </li>
              {rows.map(row => <li key={row.method} className="grid gap-2 px-6 py-5 sm:grid-cols-[220px_1fr] sm:gap-6" data-id="element-408" data-mp="2d1woc4fynwxh">
                  <div className="flex items-start gap-2" data-id="element-409" data-mp="39pjj7xxdz78t">
                    <XIcon className="mt-1 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-410" data-mp="35pshiz6bn6pi" />
                    <span className="font-semibold leading-snug text-bark" data-id="element-411" data-mp="30x7rm8qjddr9">{row.method}</span>
                  </div>
                  <p className="text-sm leading-relaxed text-ink/80" data-id="element-412" data-mp="2vy4vxewg4jvy">{row.why}</p>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}